import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.temComportamentos
    ? _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      icon: "info",
                      message: "Não há comportamentos cadastrados.",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            VRow,
            { attrs: { id: "grafico-barras", "no-gutters": "" } },
            [
              _c(
                VCol,
                [
                  _c("bar-chart", {
                    staticClass: "chart",
                    attrs: {
                      categorias:
                        _vm.graficosGeral.comportamento.bar.categorias,
                      dados: _vm.graficosGeral.comportamento.bar.dados,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      tooltip: _vm.tooltipBarChart,
                      "descricao-eixo-y": "Comportamentos Cadastrados",
                      titulo: "Monitoramento Geral de Comportamentos",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { id: "grafico-pizza", "no-gutters": "" } },
            [
              _c(
                VCol,
                [
                  _c("pie-chart", {
                    staticClass: "chart",
                    attrs: {
                      dados: _vm.graficosGeral.comportamento.pie.series,
                      "dados-complementares":
                        _vm.graficosGeral.comportamento.pie.subSeries,
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                      titulo:
                        "Comparativo de Categorias dos Comportamentos Cadastrados",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VToolbar,
                { attrs: { flat: "" } },
                [
                  _c(VToolbarTitle, [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "title primary--text text--darken-1 text-no-wrap mt-0",
                      },
                      [_vm._v(" RESULTADOS ")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-sort", {
                    model: {
                      value: _vm.opcoes,
                      callback: function ($$v) {
                        _vm.opcoes = $$v
                      },
                      expression: "opcoes",
                    },
                  }),
                ],
                1
              ),
              _c(VSpacer),
              _c(
                VCol,
                [
                  _c("app-search", {
                    model: {
                      value: _vm.opcoes,
                      callback: function ($$v) {
                        _vm.opcoes = $$v
                      },
                      expression: "opcoes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(VDataTable, {
                    staticClass: "elevation-0",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.relatorios,
                      search: _vm.opcoes.pesquisa,
                      "sort-by": _vm.opcoes.ordenarPor,
                      "sort-desc": _vm.opcoes.decrescente,
                      "align-content-space-between": "",
                      "disable-pagination": "",
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `body.append`,
                          fn: function () {
                            return [
                              _c("tr", [
                                _c(
                                  "td",
                                  { attrs: { align: "center", colspan: "2" } },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "subtitle-2 grey--text text--darken-2",
                                      },
                                      [_vm._v("TOTAL")]
                                    ),
                                  ]
                                ),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.totalGosto)),
                                  ]),
                                ]),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.totalNaoGosto)),
                                  ]),
                                ]),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.totalIdeal)),
                                  ]),
                                ]),
                                _c("td", { attrs: { align: "center" } }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.totalComportamentos)),
                                  ]),
                                ]),
                              ]),
                              _c(VDivider),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "justify-end mb-1" },
            [
              _c(
                VTooltip,
                {
                  attrs: { "max-width": "400", top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              {
                                attrs: { color: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getRelatorio()
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(VIcon, [_vm._v("get_app")]),
                              _vm._v(" BAIXAR PDF "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      "Clique para baixar o relatório dos dados em formato PDF."
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }